<template>
  <div class="taskdet-container">
  	<div class="kc-crumbs">
      <router-link :to="address">{{courseName}}</router-link>
      <img src="../../assets/img/icon-more.png">
      <a href="javascript:;" class="kc-crumbs-state">{{dataobj.taskName}}</a>
  	</div>
  	<div class="task-table">
  		<div class="task-table-title1"><span>{{dataobj.score}}学分</span>{{dataobj.taskName}}</div>
  		<div class="task-table-time"><span>培训时间：</span>{{dataobj.isForever == 2 ?'永久有效':dataobj.taskTime}}</div>
  		<div class="task-table-content"><span>任务说明：</span>{{dataobj.taskDesc}}</div>
  	</div>
  	<div class="task-content">
  		<div class="task-content-left">
  			<ul>
  				<li v-for="(item,index) in tasklist" :key="index" @click="todetail(item)">
  					<a href="javascript:;">
              <span :class="{'task-content-kc' : item.detailType == 1 , 'task-content-ks' : item.detailType == 2 }">{{item.detailType == 1 ?'课程':'考试'}}</span>
              <div class="task-content-title">{{item.detailName}}</div>
              <span :class="[{'task-content-red' : item.passStatus ==1,'task-content-gray': item.status == 1 }, 'task-content-number']">{{detailstatus(item)}}</span>
            </a>
  				</li>

          <li v-if="outerChain == 1" >
            <a :href="outerChainUrl" target="_blank" >
              <span class="task-content-kc task-content-kc">外链课程</span>
              <div class="task-content-title">{{this.dataobj.outerChainName}}</div>
              <span class="task-content-red task-content-number"></span>
            </a>
          </li>
  			</ul>
  		</div>
  		<div class="task-content-right" >
  			<div class="task-content-right-title">
  				<span>学习排名</span>
  				<a href="javascript:;" @click="morerank">更多排名<img src="../../assets/img/icon-more.png"></a>
  			</div>
  			<div class="task-content-ranking">
  				<ul>
  					<li v-for="(item,index) in ranklist" :key="index">
  						<span class="ranking-one-number" :class="classObject(item)">{{item.rank}}</span>
  						<img :src="item.userImage ? item.userImage : userImage" class="ranking-one-head" >
  						<div class="ranking-name">
  							<div class="ranking-name-name">{{item.realName}}</div>
  							<div class="ranking-name-company">{{item.position}}</div>
  						</div>
  						<span class="ranking-one-ranking">{{item.rate}}%</span>
  					</li>
  				</ul>
  			</div>
  		</div>
  		<!---->
  		<div class="kc-content-right" v-show="false">
  			<Detailphone></Detailphone>
  		</div>
  	</div>
  </div>
</template>

<script>
import Detailphone from '../CourseDetail/child/Detailphone.vue'
import {ApiGettaskTrainDetails,ApiGettaskRank} from '../../net/course/index.js'
import {getCookie,setCookie} from '../../untils/common.js'
export default {
  data: function () {
    return {
      str: '课程详情',
      lid : '',
      dataobj : {},
      tasklist :[],
      ranklist:[],
      address : '',
      courseName : '',
      userImage : 'http://statics.sgn.7east.cn/photo/20201207172318.png',
      outerChain: 0,
      outerChainUrl: ''
    }
  },
  components: {
    Detailphone,
  },
  methods:{
    getdetail(){
      const param = {taskId : this.lid}
      ApiGettaskTrainDetails(param).then(res=>{
        if(res.code == 200){
          this.dataobj = res.value;
          this.tasklist = res.value.taskDetails;
          this.outerChain = res.value.outerChain
          this.outerChainUrl = res.value.outerChainUrl || ''
        }
      }).catch(err=>{

      })
    },
    getrank(){
      const param = {
        pageNum : 1,
        pageSize : 5,
        taskId : this.lid,
        platform : 'pc'
      }
      ApiGettaskRank(param).then(res=>{
        if(res.code == 200){

          this.ranklist = res.pc.details
        }
      })
    },
    todetail(item){
	
      if(item.detailType == 1){
        setCookie('frompage','PlanDetail')
        setCookie('plid',this.lid)
        // 课程详情
        this.$router.push({
            path : 'CourseDetail',
            query : {id : item.detailId},
        })
      }else{
		//考试
		 
		if (item.studyType == 1) //自由考试
		{
         this.$router.push({
            path: '/ExamDetail',
            query: {eid:item.detailId,taskId : this.lid}
        })
		}else{
		 
		 if (this.dataobj.courseTotal==this.dataobj.courseFinish) //总课程数量等于已学完课程数量可以考试
		 {
			this.$router.push({
				path: '/ExamDetail',
				query: {eid:item.detailId,taskId : this.lid}
			})
		}
		else{
			//this.$message.error('请学习完所有课程再来参加考试!')
			this.$message({
				message: '请学习完所有课程再来参加考试!',
				type: 'warning'
			})
		}
		}
      }
    },
    classObject(item){
      return {
        rank1: item.rank==1,
        rank2:item.rank==2,
        rank3:item.rank==3,
        rank_member : item.rank==3||item.rank==2||item.rank==1
      }
    },
    morerank(){
      setCookie('plid',this.lid)
      this.$router.push({
        path : 'RankList',
        query:{id:this.lid,courseName:this.dataobj.taskName}
      })
    }
  },
  computed: {

  },
  created() {
    this.lid = this.$route.query.id;
  },
  mounted() {
    switch (getCookie('frompage1')){
      case 'home':
      this.courseName = '首页'
      this.address = '/'
      break
      case 'Accound':
      this.courseName = '个人中心'
      this.address = '/Accound'
      break
    }
   //console.log(getCookie('frompage'))
   this.getdetail();
   this.getrank();
   this.$store.commit('afterEach')
  },
  computed: {
    detailstatus() {
      return function(item){
        if(item.detailType == 1){
          return item.rate+'%'
        }else{
          if(item.status == 1){
            return '未开始'
          }else if(item.status == 2){
            return '进行中'
          }else{
            if(item.passStatus == 1){
              return '未及格'
            }else{
              return '及格'
            }

          }
        }
      }
    }
  },
}
</script>

<style scoped>
    .kc-crumbs{
			width: 1140px;
			margin: 0 auto;
			margin-top: 20px;
			margin-bottom: 20px;
			overflow: hidden;
		}
		.kc-crumbs a{
			font-size: 16px;
			color: #7f7f7f;
			text-decoration: none;
			float: left;
		}
		.kc-crumbs img{
			width: 16px;
			height: 16px;
			float: left;
			margin-top: 4px;
			margin-left: 2px;
			margin-right: 2px;
		}
		.kc-crumbs a.kc-crumbs-state{
			color: #252525;
		}
		.kc-crumbs a:hover{
			color: #0AAC50;
		}
		.taskdet-container{
			width: 1140px;
			margin:0 auto;
		}
		.task-table{
			width: 1060px;
			margin:20px auto 0;
			padding: 40px;
			background:#fff;
			border-radius: 6px;
			overflow: hidden;

		}
		.task-table-title1{
      font-size: 20px;
      color: #252525;
      line-height: 1.5;
      font-weight: bold;
      width:1060px;
      float:left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 20px;
      height: 30px;
      line-height: 30px;
      float: left;
		}
		.task-table-title1 span{
			font-size: 14px;
			color: #FF5500;
			font-weight: bold;
			padding: 3px 4px;
			background: #FFEAE0;
			border-radius: 2px;
			margin-right: 10px;
		}
		.task-table-time{
			font-size: 14px;
			color: #454545;
			width: 1060px;
			float: left;
			margin-bottom: 20px;
		}
		.task-table-time span{
			color: #7f7f7f;
		}
		.task-table-content{
			font-size: 14px;
			color: #454545;
			width: 1060px;
			float: left;
			line-height: 1.7;
		}
		.task-table-content span{
			color: #7f7f7f;
		}
		.task-content{
			width: 1140px;
			margin: 0 auto;
			margin-top: 24px;
			overflow: hidden;
		}
		.task-content-left{
			width:752px;
			background:#fff;
			border-radius: 6px;
			float:left;
			min-height: 480px;
			padding-bottom: 20px;
		}
		.task-content-left ul{
			margin:0;
			padding:0;
		}
		.task-content-left ul li{
			list-style-type: none;
			overflow: hidden;
		}
		.task-content-left ul li a{
			text-decoration: none;
			margin-left: 30px;
			margin-right: 30px;
			padding-top: 20px;
			padding-bottom: 20px;
			float: left;
			width: 692px;
			border-bottom: 1px solid #e5e5e5;
		}
		.task-content-kc{
			width: 36px;
			height: 20px;
			border-radius: 2px;
			font-size: 14px;
			background: #2D90EC;
			float: left;
			text-align: center;
			line-height: 20px;
			color: #fff;
		}
		.task-content-title{
			float: left;
			font-size: 18px;
			color: #252525;
			margin-left: 10px;
			line-height: 20px;
			width: 590px;
		}
		.task-content-number{
			color:#019B3C;
			font-size: 16px;
			float: right;
		}
		.task-content-ks{
			width: 36px;
			height: 20px;
			border-radius: 2px;
			font-size: 14px;
			background: #FA5151;
			float: left;
			text-align: center;
			line-height: 20px;
			color: #fff;
		}
		.task-content-45{
			color:#454545;
			font-weight: normal;
		}
		.task-content-red{
			color: #FA5151;
		}
    .task-content-gray{
      color: #C2C2C2;
    }
		.task-content-right{
			float: right;
			width: 364px;
			background:#fff;
			border-radius: 6px;
			height: 500px;
		}
		.task-content-right-title{
			padding: 20px;
			border-bottom: 1px solid #e5e5e5;
		}
		.task-content-right-title span{
			font-size: 18px;
			color: #252525;
			font-weight: bold;
			line-height: 20px;

		}
		.task-content-right-title a{
			float: right;
			font-size: 14px;
			color: #999;
			line-height: 20px;
			text-decoration: none;
		}
		.task-content-right-title a img{
			width: 16px;
			height: 16px;
			margin-top: 3px;
			float: right;
		}
		.task-content-ranking{
			padding-left: 20px;
			padding-right: 20px;
		}
		.task-content-ranking ul{
			margin:0;
			padding:0;
		}
		.task-content-ranking ul li{
			list-style-type: none;
			height: 36px;
			border-bottom: 1px solid #e5e5e5;
			padding-top: 20px;
			padding-bottom: 20px;
		}
		.ranking-one-number{
			width: 30px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			float: left;
			margin-top: 3px;
			color: #7f7f7f;
		}
		.ranking-one-head{
			width:36px;
			height: 36px;
			border-radius: 50%;
			float:left;
			margin-left: 10px;
		}
		.ranking-name{
			float: left;
			margin-left: 10px;
			width: 180px;
		}
		.ranking-name-name{
			float: left;
			font-size: 14px;
			color: #252525;
			width: 180px;
			line-height: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.ranking-name-company{
			float: left;
			font-size: 14px;
			line-height: 18px;
			color: #7f7f7f;
			width:180px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.ranking-one-ranking{
			height: 36px;
			line-height: 36px;
			float: right;
		}
		.kc-content-right{
			margin-left:24px;
			width: 304px;
			background:#fff;
			float: right;
			border-radius: 6px;

		}
		.kc-content-right img{
			width: 48px;
			height: 48px;
			padding-top: 40px;
			padding-bottom: 40px;
			padding-left: 30px;
			float: left;;
		}
		.kc-phone-table{
			height: 48px;
			float: left;
			margin-top: 40px;
			margin-left: 20px;
		}
		.kc-phone-table-title{
			font-size: 16px;
			color: #7f7f7f;
		}
		.kc-phone-table-content{
			font-size: 20px;
			color: #252525;
		}
    .rank1{
      background-image: url(../../assets/img/ranking-one1.png);
    }
    .rank2{
      background-image: url(../../assets/img/ranking-two1.png);
    }
    .rank3{
      background-image: url(../../assets/img/ranking-three1.png);
    }
    .rank_member{
      background-size: cover;
      background-position: 0 2px;
      background-repeat: no-repeat;
      color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/PlanDetail/PlanDetail.vue